import request from '../utils/request';

/**
 * 获取企业认证信息分页列表
 * @param {Object} params 查询参数
 * @returns {Promise} 请求结果
 */
export const getVerificationList = (params) => {

  return request({
    url: '/business/verification/list',
    method: 'get',
    params
  });
};

/**
 * 获取企业认证审核队列分页列表
 * @param {Object} params 查询参数
 * @returns {Promise} 请求结果
 */
export const getQueueList = (params) => {
  return request({
    url: '/business/verification/queue/list',
    method: 'get',
    params
  });
};

/**
 * 审核通过企业认证
 * @param {number} id 认证ID
 * @param {number} operatorId 审核人ID
 * @returns {Promise} 请求结果
 */
export const approveVerification = (id, operatorId) => {
  return request({
    url: `/business/verification/${id}/approve`,
    method: 'put',
    params: { operatorId }
  });
};

/**
 * 拒绝企业认证
 * @param {number} id 认证ID
 * @param {string} rejectReason 拒绝原因
 * @param {number} operatorId 审核人ID
 * @returns {Promise} 请求结果
 */
export const rejectVerification = (id, rejectReason, operatorId) => {
  return request({
    url: `/business/verification/${id}/reject`,
    method: 'put',
    params: { rejectReason, operatorId }
  });
}; 